@let vm = vm$ | async;

@if (vm) {
  <div class="pu-team-bonuses__header">
    <h4 class="pu-team-bonuses__header-text">
      {{ 'personalInfo.teamBonus.header' | translate }}
    </h4>

    <button
      class="pu-team-bonuses__close"
      type="button"
      puButton
      size="m"
      uiType="quaternary"
      [onlyIcon]="true"
      (click)="close('close_button')"
    >
      <pu-icon
        iconName="close"
        size="16"
      />
    </button>
  </div>

  <div class="pu-team-bonuses__body">
    <div class="pu-team-bonuses__tabs">
      @for (tab of tabs; track tab.id) {
        <button
          class="pu-team-bonuses__tab"
          [class.pu-button_pressed]="type === tab.id"
          type="button"
          puButton
          uiType="gradient"
          size="s"
          [innerHTML]="tab.name"
          (click)="setType(tab.id)"
        >
        </button>
      }
    </div>

    @if (vm.teamBonus && vm.teamAwards) {
      @switch (type) {
        @case ('bonus') {
          <pu-bonus-form
            [functionalUsers]="vm.teamBonus.functionalUsers"
            [bonusTotal]="vm.teamBonus.amount"
          />
        }
        @case ('awards') {
          <pu-awards-form
            [teamAwards]="vm.teamAwards"
            [openedFromPersonalInfo]="openedFromPersonalInfo"
            (closeModal)="close('cancel_button')"
          />
        }
      }
    }
  </div>
}
